import { render } from "./HeroiconsSolidUserRemove.vue?vue&type=template&id=568f5ae8"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUserRemove.vue"]])

export default __exports__